import { BookOpenText, ClipboardCheck, Eye, MessageCircle } from "lucide-react";
import type { LearningPresentation } from "../types/learning-presentation.js";
import { LearningVideoStill } from "./LearningVideoStill.js";

export function LearningThumbnail({
  presentation,
  resourceId,
  title,
}: {
  presentation: LearningPresentation;
  resourceId: string;
  title: string;
}) {
  if (presentation.format === "video")
    return (
      <LearningVideoStill
        compact
        imageSrc={presentation.imageSrc}
        resourceId={resourceId}
        title={title}
        vimeoVideos={presentation.vimeoVideos}
      />
    );
  return (
    <div
      aria-hidden="true"
      className={`flex aspect-video items-center justify-center gap-1.5 rounded-xl border border-border/50 ${presentation.format === "text" ? "bg-primary/5 text-primary" : "bg-info text-info-foreground"}`}
    >
      {presentation.format === "text" ? (
        <>
          <BookOpenText className="size-8" strokeWidth={1.5} />
          <div className="space-y-1.5">
            <div className="h-1 w-6 rounded bg-current opacity-50" />
            <div className="h-1 w-8 rounded bg-current opacity-25" />
            <div className="h-1 w-5 rounded bg-current opacity-25" />
          </div>
        </>
      ) : (
        [Eye, MessageCircle, ClipboardCheck].map((Icon, index) => (
          <div className="flex flex-col items-center gap-1" key={index}>
            <Icon className="size-5" strokeWidth={1.5} />
            <span className="size-1 rounded-full bg-current" />
          </div>
        ))
      )}
    </div>
  );
}
